export default __webpack_public_path__ + "static/media/encoder.76fe9b3e.png";